import React, { useState } from "react";
import axios from "axios";
import "./App.css";

export default function Fotos(props) {
  const [loaded, setLoaded] = useState(false);
  const [foto, setFoto] = useState({});
  const query = props.query;

  function handleResponse(response) {
    console.log(response);
    setLoaded(true);
    setFoto({
      alt: response.data.photos[0].alt,
      height: response.data.photos[0].height,
      width: response.data.photos[0].width,
      url: response.data.photos[0].url,
      landscape: response.data.photos[0].src.landscape,
      portrait: response.data.photos[0].src.portrait,
      photos: response.data.photos,
    });
  }

  if (loaded) {
    return (
      <div className="section">
        <div className="row">
          {foto.photos.map(function (photo, index) {
            if (index < 4) {
              return (
                <div className="col" key="index">
                  <img
                    src={photo.src.landscape}
                    alt={photo.alt}
                    className="img-fluid"
                  ></img>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    let APIkey = "5fobe02b0dff93d79ecc47a523d0f3t0";

    let APIurl = `https://api.shecodes.io/images/v1/search?query=${query}&key=${APIkey}`;
    axios.get(APIurl).then(handleResponse);

    return <div className="section">Loading...</div>;
  }
}
